import { jsx as _jsx } from "react/jsx-runtime";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { BROWSER_SELECTOR } from "../backbone/mediaLibraryShared.js";
import { UploadMessage } from "../components/common/uploadMessage.js";
import { getDefaultTreeStore, getRmlTreeStore } from "../hooks/tree/bridge/rmlMediaBridge.js";
let uploaderFetchCountsTimeout;
let uploadNotificationRoot;
let uploadNotificationHost;
let currentUploader;
function getActiveTreeStore() {
    let activeStore = getDefaultTreeStore();
    $(BROWSER_SELECTOR).each(function() {
        const treeStore = getRmlTreeStore($(this).data("backboneView"));
        if (treeStore) {
            activeStore = treeStore;
            return false;
        }
    });
    return activeStore;
}
function hideMessage() {
    uploadNotificationRoot?.render(null);
    uploadNotificationHost?.remove();
    uploadNotificationRoot = undefined;
    uploadNotificationHost = undefined;
}
function renderUploadNotification() {
    const activeStore = getActiveTreeStore();
    if (!activeStore.currentUpload) {
        return;
    }
    if (!uploadNotificationHost) {
        uploadNotificationHost = document.createElement("div");
        uploadNotificationHost.className = "rml-upload-notification-host";
        document.body.appendChild(uploadNotificationHost);
        uploadNotificationRoot = createRoot(uploadNotificationHost);
    }
    uploadNotificationRoot.render(/*#__PURE__*/ _jsx(UploadMessage, {
        store: activeStore,
        onCancel: cancelUpload
    }));
}
function afterUpload(up) {
    const hadRelativePathUploads = up.files.filter((f)=>f.getSource().relativePath?.split("/").length > 2).length;
    up.splice();
    up.total.reset();
    clearTimeout(uploaderFetchCountsTimeout);
    uploaderFetchCountsTimeout = setTimeout(()=>{
        if (hadRelativePathUploads) {
            $(BROWSER_SELECTOR).each(function() {
                const backboneView = $(this).data("backboneView");
                if (backboneView) {
                    backboneView.controller.rmlMediaBridge?.refreshTree();
                }
            });
        } else {
            getActiveTreeStore().fetchCounts();
        }
    }, 500);
    hideMessage();
}
function cancelUpload() {
    currentUploader.stop();
    afterUpload(currentUploader);
    currentUploader.start();
}
function showMessage(up) {
    currentUploader = up;
    renderUploadNotification();
}
export { afterUpload, cancelUpload, getActiveTreeStore, renderUploadNotification, showMessage };
